import axios from "axios";
import { API_URL } from "../constants";

export const fetch = (companyId, filtersValue, options = {}) => {
  const url = `${API_URL}/${companyId}/product-groups/fetch`;
  // Pagination is opt-in. Without `page` the backend returns the full list
  // (used by the product/group selectors).
  const body = { filtersValue };
  if (options && options.page != null) {
    body.page = options.page;
    body.pageSize = options.pageSize;
  }
  return axios.post(url, body).then((response) => response.data);
};

export const post = (companyId, data) => {
  const url = `${API_URL}/${companyId}/product-groups`;
  return axios.post(url, data).then((response) => response.data);
};

export const patch = (companyId, id, data) => {
  const url = `${API_URL}/${companyId}/product-groups/${id}`;
  return axios.patch(url, data).then((response) => response.data);
};

export const fetchById = (companyId, id) => {
  const url = `${API_URL}/${companyId}/product-groups/${id}`;
  return axios.get(url).then((response) => response.data);
};


